import AuthService from 'services/auth.service';
import layoutNames from 'utils/enums/layout-names.enum';

export const requireLogin = (to, from, next) => {
	if (to.meta.auth) {
		if (AuthService.getCurrentUser()) {
			next();
		}
		next.redirect(`/${layoutNames.auth}/login`);
	} else {
		if (to?.location?.pathname === `/${layoutNames.auth}/login`) {
			if (AuthService.getCurrentUser()) {
				if (from?.location?.pathname !== `/${layoutNames.auth}/login`) {
					next.redirect(from?.location?.pathname);
				} else {
					next.redirect('/');
				}
				return;
			}
		}
		next();
	}
};

export const requireUnlocked = (to, from, next) => {
	if (to.meta.auth) {
		if (AuthService.getLocked()) {
			next.redirect(`/${layoutNames.auth}/lock`);
		}
		next();
	} else {
		if (to?.location?.pathname === `/${layoutNames.auth}/lock`) {
			if (!AuthService.getLocked()) {
				next.redirect(from?.location?.pathname);
				return;
			}
		}
		next();
	}
};

export const filterRoutesByUserRole = (routeProp) => {
	const user = AuthService.getCurrentUser();
	if (!routeProp?.allowedFor || routeProp?.allowedFor?.includes(user?.role)) {
		return true;
	}
	return false;
};
